import {
    Table,
    TableColumn,
    TableRow,
    TableHeaderTheme,
    TableRowTheme,
    TableBorderRadius,
    TableBorderStyle,
    AddressLocation,
    AddressLocationControlPadding,
    AddressLocationFontSize,
    AddressLocationIndicatorStyle,
    AddressLocationLine1Style,
} from '@apply/components';
import { GeneralContractorCell } from './components/GeneralContractorCell';
import { ActionsCell } from './components/ActionsCell/ActionsCell';
import { GCUserProperty } from '@apply/api/src/api/ApplyApi';
import { addressBuilder } from '../../constants/addressBuilder';
import { GCRoleType } from '@apply/constants';

export interface PropertiesTableProps {
    isPortfolio: boolean;
    properties: GCUserProperty[];
    onRefresh: () => void;
}

export const PropertiesTable: React.FC<PropertiesTableProps> = ({ isPortfolio, properties, onRefresh }) => {
    const renderGeneralContractor = (generalContractor: string | undefined, role: GCRoleType | undefined) => {
        return (
            <GeneralContractorCell
                generalContractName={generalContractor}
                role={role}
            />
        );
    };

    const renderPropertyAddress = (property: GCUserProperty) => {
        return (
            <AddressLocation
                addressLine1={addressBuilder(property)}
                indicatorStyle={AddressLocationIndicatorStyle.Gray}
                line1Style={AddressLocationLine1Style.Regular}
                controlPadding={AddressLocationControlPadding.None}
                fontSize={AddressLocationFontSize.Smaller}
            />
        );
    };

    const renderActions = (propertyId: number, userId: string) => {
        return (
            <ActionsCell
                propertyId={propertyId}
                userId={userId}
                onRefresh={onRefresh}
            />
        );
    };

    const data: TableRow[] = properties.map((property) => {
        return {
            propertyAddress: renderPropertyAddress(property),
            generalContractor: renderGeneralContractor(property.gcName || undefined, property.role ?? undefined),
            actions: renderActions(property.propertyId, property.gcUserId),
        };
    });

    return (
        <>
            <Table
                headerTheme={TableHeaderTheme.Transparent}
                rowTheme={TableRowTheme.Transparent}
                borderRadius={TableBorderRadius.None}
                borderStyle={TableBorderStyle.None}
                showHeader={false}
                data={data}
                width='100%'
            >
                <TableColumn
                    columnKey='propertyAddress'
                    header='Property Address'
                    width='40%'
                    visible={isPortfolio}
                />
                <TableColumn
                    columnKey='generalContractor'
                    header='Assigned User'
                    width={!isPortfolio ? '80%' : '40%'}
                />
                <TableColumn
                    columnKey='actions'
                    header='Actions'
                    width='20%'
                    showHeaderOnWrap={false}
                    actionColumn={false}
                />
            </Table>
        </>
    );
};
